import HeaderNav from "./HeaderNav";
import { useEffect } from "react";

export default function Header() {
    useEffect(() => {
    const header = document.querySelector(".header");

    const onScroll = () => {
      if (window.scrollY > 0) {
        header.classList.add("shrink");
      } else {
        header.classList.remove("shrink");
      }
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

    return (
        <header className ="header">
            <div className="headerLogoSection">
                    
                <a href="/" className="flex mr-2 gap-2">
                    <img
                        src="/images/logo.png"
                        alt="Matly logo"
                        className="h-12 w-12 rounded-lg"
                    />
                    <span className="headerTitle">matly</span>
                </a>
            </div>

            <HeaderNav />
        </header>
    )
}